// extracted by mini-css-extract-plugin
export default {"PropertyTenantSelectionHeader":"HoGTDKgdpjQw9mOtjMo2yA== P4YIyCcI5dpGUGRuJSQmNA==","WithMargin":"kvaGHMwiRSr1O7F7+M9Whw=="};